import { FC } from 'react';
import isEmpty from 'lodash/isEmpty';

import {
  FilteredTopCampaign,
  useBrandAffinityXAIContext,
} from 'modules/ai/XAI/audienceUserProfile';

import { CampaignData } from './CampaignData';
import { CampaignSkeleton } from './CampaignSkeleton';
import { EVENT_ICONS } from '../../../../events/constants';
import {
  ensureSystemEvent,
  formatToDisplayDate,
  getRelativeToMonthSpan,
  formatActionWithMedium,
} from '../utils';
import {
  CampaignsCard,
  CampaignsDataContainer,
  CampaignsDividerText,
  CampaignsHistoryContainer,
  HeaderContainer,
  AlignedDisabledText,
} from './CampaignCard.styles';
import { CardTitle } from '../Styles';

export const CampaignHistory: FC = () => {
  const { isError, isLoading, campaignsData = [], previewData } = useBrandAffinityXAIContext();

  let earlyExitContent: JSX.Element | null = <CampaignSkeleton />;
  if (!isLoading) {
    if (isError) {
      earlyExitContent = (
        <AlignedDisabledText data-test="brand-affinity-xai-campaign-error">
          No data available
        </AlignedDisabledText>
      );
    } else {
      earlyExitContent = isEmpty(campaignsData) ? (
        <AlignedDisabledText>No campaign sends</AlignedDisabledText>
      ) : null;
    }
  }

  return (
    <CampaignsHistoryContainer data-test="brand-affinity-xai-campaign-history">
      <CampaignsDividerText>
        Contributing factors over <strong>past 90 days</strong>
      </CampaignsDividerText>
      <CampaignsCard>
        <HeaderContainer>
          <CardTitle>Top contributing campaigns</CardTitle>
        </HeaderContainer>
        <CampaignsDataContainer>
          {earlyExitContent ||
            campaignsData.map((campaign: FilteredTopCampaign) => {
              const { action, channel, date, id, name, templateId } = campaign;
              const templateUrl = (previewData || {})[templateId];
              const Icon = EVENT_ICONS[ensureSystemEvent(channel, action)];

              return (
                <CampaignData
                  date={formatToDisplayDate(date)}
                  eventData={formatActionWithMedium(action, channel)}
                  EventIcon={Icon}
                  imgSrc={templateUrl}
                  id={id}
                  key={`${name}_${templateId}`}
                  name={name}
                  relativeDate={getRelativeToMonthSpan(date)}
                />
              );
            })}
        </CampaignsDataContainer>
      </CampaignsCard>
    </CampaignsHistoryContainer>
  );
};
